import { gql } from 'graphql-tag'

export const GET_CONSUMER_ADDRESS_IMAGE_UPLOAD_URL = gql`
  query getConsumerAddressImageUploadUrl($addressId: String!, $fileName: String!, $imageType: AddressImageType!) {
    getConsumerAddressImageUploadUrl(addressId: $addressId, fileName: $fileName, imageType: $imageType) {
      imageUrl
      key
      uploadUrl
    }
  }
`
